import { useContext } from 'react';
import { PoolInfoContext } from '@/components/providers/poolInfo';

export const usePoolInfoContext = () => {
  return useContext(PoolInfoContext);
};

export const usePoolId = () => {
  const { poolInfo } = usePoolInfoContext();
  return poolInfo?.id;
};

export const usePoolChainCode = () => {
  const { poolInfo } = usePoolInfoContext();
  return poolInfo?.chainCode;
};
